import { useUserProvider } from '@/context/UserProvider';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { fetchInsPostCommentUserSubData } from '@/lib/service/anonymously';

export default function useCommentViewPremium() {
  const { isLogin } = useUserProvider();
  const [isPermiumUser, setIsPermiumUser] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (!isLogin) {
      setIsPermiumUser(false);
    } else {
      fetchInsPostCommentUserSubData().then((res) => {
        if (res.code === 0) {
          setIsPermiumUser(!!res.data?.package_type);
        }
      });
    }
  }, [router, isLogin]);

  return {
    isPremium: isLogin && isPermiumUser,
  };
}
